import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { useState, useRef } from "react";
// import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { ConfirmationModal } from "../../../common/ConfirmationModal";
import { AlertModal } from "../../../common/AlertModal";


const CompleteJobcard = (props) => {
  const { t } = useTranslation();
  const formRef = useRef(null);
  const [confirmModel, setConfirmModel] = useState(false);
  const [isAlert, setIsAlert] = useState(false);

  const handleForceComplete = () => {
    const form = formRef.current;
    if (form[0].value) {
      setConfirmModel(false)
      props.completeFunction(form[0].value)
    } else {
      setConfirmModel(false)
      setIsAlert(true)
    }

  }

  const resetAlert = () => {
    setIsAlert(false);
  };

  return (
    <>
      <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter">
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Complete Jobcard
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="qr-code">
          <Form noValidate  ref={formRef}>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label className="col-form-label">
                {"Please Enter Remarks, Why you are Completing Jobcard ?"}
              </Form.Label>
              <Form.Control
                as="textarea"
                // value={address || ""}
                rows={4}
               // onChange={(e) => setRemarks(e.target.value)}
                required
                autoFocus
              />
              <Form.Control.Feedback type="invalid">
                {t("msg_master_list.msg_customer.customer_address_validation")}
              </Form.Control.Feedback>
            </Form.Group>

          </Form>
          <Button
            type="button"
            variant="success"
            className="btn btn-success float-right"
            onClick={() => setConfirmModel(true)}
          >
            {"Force Complete"}
          </Button>
        </Modal.Body>
      </Modal>
      {confirmModel && (
        <ConfirmationModal
          show={confirmModel}
          heading={"Complete Jobcard"}
          bodyMessage={"Once Jobcard is Completed it cant be Reversed. Do you want to Forcefully Complete Jobcard ?"}
          onOk={() => handleForceComplete()}
          onHide={() => setConfirmModel(false)}
          type={"common"}
        ></ConfirmationModal>
      )}

      {isAlert && (
        <AlertModal
          show={isAlert}
          heading={t("msg_common.alert")}
          bodyMessage={"Please Enter some value."}
          onHide={() => {
            resetAlert();
          }}
        ></AlertModal>
      )}
    </>
  );
}

export default CompleteJobcard;
